import { render, staticRenderFns } from "./EditarEstados.vue?vue&type=template&id=0f436eb6&scoped=true&"
import script from "./EditarEstados.vue?vue&type=script&lang=js&"
export * from "./EditarEstados.vue?vue&type=script&lang=js&"
import style0 from "./EditarEstados.vue?vue&type=style&index=0&id=0f436eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f436eb6",
  null
  
)

export default component.exports